export const BackupPaneName = 'outline-backup-pane';
export const MasterPaneName = 'outline-master-pane';